var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Checkbox abc-checkbox"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.id},domProps:{"checked":_vm.value},on:{"change":_vm.onChange,"click":_vm.onClick}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b0b7794","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/Checkbox/checkbox.vue
// module id = null
// module chunks = 